import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svg/SvgIcon';

const iconStyle = {
  width: 34,
  height: 34,
};

const Create = ({ color, style, ...props }) => (
  /* eslint-disable max-len */
  <SvgIcon {...props} viewBox="0 0 696 1086" style={{ ...style, ...iconStyle }}>
    <path
      fill={color || '#C4C8CE'}
      d="M572 227l105 109c10 11 19 34 19 49v323c0 15-12 29-28 29H481v-49h157c5 0 9-4 9-9V407c0-5-4-9-9-9H522c-5 0-10-4-10-9V265c0-5-4-9-9-9H313c-5 0-10 4-10 9v69c-10-4-23-6-33-6h-15v-93c0-16 13-28 28-28h242c15 0 37 9 47 20zm-2 122h42c5 0 6-3 3-7l-48-49c-3-4-6-3-6 2v45c0 5 4 9 9 9zm-252 38l104 110c11 11 19 33 19 48v323c0 16-12 29-27 29H29c-16 0-29-13-29-29V395c0-15 13-29 29-29h241c15 0 37 10 48 21zM58 848h325c5 0 10-4 10-9V567c0-5-5-9-10-9H267c-5 0-9-4-9-9V425c0-5-4-9-9-9H58c-5 0-9 4-9 9v414c0 5 4 9 9 9zm302-345l-47-51c-4-4-7-1-7 4v44c0 5 5 9 10 9h41c5 0 7-3 3-6z"
    />
  </SvgIcon>
  /* eslint-enable max-len */
);

export default pure(Create);
